/* eslint-disable vue/no-parsing-error */
import { httpClient, customerHttp, metaGen } from './_http';

const post = (url, payload, opts = {}) =>
	  httpClient.post(url, payload, {
      baseURL: '/gw/customer-server'
});
const get = (url, payload, opts = {}) =>
	  httpClient.get(url, payload, {
      baseURL: '/gw/customer-server'
});

// 线上签署 合同
export const onlineFlowOneStep = (payload = {}) => {
    return post('/customer-contract/online/flow-one-step', {
        meta: metaGen(),
        params: {
            ...payload
        }
    });
};

// 签署 合同 资格
export const needContract = (payload = {}) => {
    return post('/customer-contract/need-contract', {
        meta: metaGen(),
        params: {
            ...payload
        }
    });
};

// 签署 合同 认证结果轮询
export const contractStatus = (payload = {}) => {
    return post('/customer-contract-flow/status', {
        meta: metaGen(),
        params: {
            ...payload
        }
    });
};

// 签署 合同 信息
export const currentEffective = (payload = {}) => {
    return post('/customer-contract/current-effective', {
        meta: metaGen(),
        params: {
            ...payload
        }
    });
};

// 创建企业成员
export const createCompanyUser = (data = {}) => {
    return httpClient.post('/user/creataccountpasswordharbour', data);
};
// 获取个人核身认证地址
export const userAuthUrl = (data = {}) => {
    return post('/user/user-auth/url', {
        meta: {
            code: 'CUSTOMER',
            client: 'web',
            tag: 'default',
            time: Date.now()
        },
        params: data
    });
};

// 个人认证结果轮询
export const userAuthStatus = (data = {}) => {
    return post('/user/user-auth/status', {
        meta: {
            code: 'CUSTOMER',
            client: 'web',
            tag: 'default',
            time: Date.now()
        },
        params: data
    });
};

// 获取企业核身认证地址
export const orgAuthUrl = (data = {}) => {
    return post('/company/org-auth/url', {
        meta: {
            code: 'CUSTOMER',
            client: 'web',
            tag: 'default',
            time: Date.now()
        },
        params: data
    });
};

// 企业认证结果轮询
export const orgAuthStatus = (data = {}) => {
    return post('/company/org-auth/status', {
        meta: {
            code: 'CUSTOMER',
            client: 'web',
            tag: 'default',
            time: Date.now()
        },
        params: data
    });
};

// 获取个人信息
export const userInfo = (data = {}) => {
    return post('/user/info1', {
        meta: {
            code: 'CUSTOMER',
            client: 'web',
            tag: 'default',
            time: Date.now()
        },
        params: data
    });
};

// 剩余不认证的天数
export const remain = (data = {}) => {
    return post('/company/certification/remain', {
        meta: {
            code: 'CUSTOMER',
            client: 'web',
            tag: 'default',
            time: Date.now()
        },
        params: data
    });
};

// 修改员工等级
export const characterUpdate = (data = {}) => {
    return post('/user/character-position/update', {
        meta: {
            code: 'CUSTOMER',
            client: 'web',
            tag: 'default',
            time: Date.now()
        },
        params: data
    });
};

// 移出企业
export const removeCompany = (data = {}) => {
    return post('/user/remove-company', {
        meta: {
            code: 'CUSTOMER',
            client: 'web',
            tag: 'default',
            time: Date.now()
        },
        params: data
    });
};

// 下载 合同
export const downloadFile = (payload = {}) => {
    return post('/customer-contract/download', {
        meta: metaGen(),
        params: {
            ...payload
        }
    });
};

// 线下签署 合同
export const contractApply = (payload = {}) => {
    return post('/customer-contract-apply/apply', {
        meta: metaGen(),
        params: {
            ...payload
        }
    });
};

// 发起授权书签署 合同
export const createFlowOneStep = (data = {}) => {
    return post('/customer-contract-authorization/createFlowOneStep', {
        meta: metaGen(),
        params: data
    });
};

// 发起授权书签署 合同
export const sendMessage = (data = {}) => {
    return post('/customer-contract-authorization/send-message', {
        meta: metaGen(),
        params: data
    });
};

// 认证提醒
export const certificationAlert = (data = {}) => {
    return customerHttp.get('/user/should-certification-alert', {
        meta: metaGen(),
        params: data
    });
};

// 签署合同确认 新增弹框

export const confrimContent = (data = {}) => {
    return customerHttp.get('/company-customer-rel/is-exist-contract-apply-audited-by-company-id', {
        meta: metaGen(),
        params: data
    });
};



// WEBPACK FOOTER //
// ./src/api/certification.js